import React from "react";
import { Alert } from "@material-ui/lab";
import { Chip, Tooltip } from "@material-ui/core";
import { ReportProblemOutlined } from "@material-ui/icons";

// Aviso exibido nos cadastros de conexão e de usuário quando nenhuma fila
// está selecionada. É a causa mais comum de "não chega atendimento": sem
// vínculo com fila a conexão não roteia e o usuário não enxerga os tickets.
const MESSAGES = {
  connection:
    "Sem fila vinculada, as conversas desta conexão não são direcionadas a nenhum departamento.",
  user:
    "Sem fila, este usuário não verá os atendimentos dos departamentos. Selecione ao menos uma.",
};

const NoQueueWarning = ({ type }) => (
  <Alert severity="warning" style={{ marginTop: 8, marginBottom: 4 }}>
    {MESSAGES[type]}
  </Alert>
);

export default NoQueueWarning;

// Versão compacta para as listas de Conexões e Usuários.
export const NoQueueChip = ({ type }) => (
  <Tooltip title={MESSAGES[type]}>
    <Chip
      size="small"
      icon={<ReportProblemOutlined style={{ color: "#ED6C02" }} />}
      label="Sem fila"
      style={{
        backgroundColor: "rgba(237,108,2,0.12)",
        color: "#ED6C02",
        fontWeight: 600,
        fontSize: "0.72rem",
        height: 22,
        marginLeft: 4,
      }}
    />
  </Tooltip>
);
